export default __webpack_public_path__ + "static/media/logo-vodafone.b3e8486c.svg";